const getOffsetTop = element => {
    let offsetTop = 0

    while ( element ) {
        offsetTop += element.offsetTop
        element = element.offsetParent
    }

    return offsetTop
}

// Native smooth scrolling:
const nativeSmoothScrollTo = elem => {
    window.scroll( {
        behavior: 'smooth',
        left: 0,
        top: elem.getBoundingClientRect().top + window.pageYOffset
    } )
}

// Polyfilled smooth scrolling:
export const smoothScrollTo = ( to, duration = 1000 ) => {
    const element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date()

    // t = current time
    // b = start value
    // c = change in value
    // d = duration
    const easeInOutQuad = ( t, b, c, d ) => {
        t /= d / 2

        if ( t < 1 ) {
            return c / 2 * t * t + b
        }

        t--

        return -c / 2 * ( t * ( t - 2 ) - 1 ) + b
    }

    const animateScroll = _ => {
        const currentDate = +new Date()
        const currentTime = currentDate - startDate
        element.scrollTop = parseInt( easeInOutQuad( currentTime, start, change, duration ) )

        if ( currentTime < duration ) {
            requestAnimationFrame( animateScroll )
        } else {
            element.scrollTop = to
        }
    }

    animateScroll()
}

export const scrollToElement = ( element, duration = 1000, offset = 0 ) => {
    if ( ! element ) {
        return
    }

    const offsetTop = getOffsetTop( element ) + offset

    // const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style

    // if ( supportsNativeSmoothScroll ) {
    //  nativeSmoothScrollTo( element )
    // } else {
    //  smoothScrollTo( element.offsetTop, 1000 )
    // }

    smoothScrollTo( offsetTop, duration )
}



// WEBPACK FOOTER //
// ./utilities/scroll.jsx